import React from 'react';

import { CardPageFastFilters } from '@vlabs/monokit/entities/card/filters';
import { DeleteCardsButton } from '@vlabs/monokit/features/delete-cards';
import { useCardIdFromLocation } from '@vlabs/monokit/shared/lib/use-card-id-from-location';
import { PersonFiles, PersonLists, CardFacesViewer } from '@vlabs/monokit/widgets';
import { routes } from '@vlapps/point/src/app/routes';
import { generatePath, useHistory } from 'react-router-dom';

import { CardGeneralInfo } from '../card-general-info';
import { CardPageHeader } from '../card-page-header';
import st from './CardPageContent.module.sass';

export function CardPageContent(): React.JSX.Element {
  const cardId = useCardIdFromLocation();
  const history = useHistory();

  return (
    <div className={st.CardPageContent}>
      <CardPageHeader />

      <div className={st.Layout}>
        <div className={st.Sidebar}>
          <div className={st.SidebarContent}>
            <CardGeneralInfo />
            <PersonLists />
            <PersonFiles />
          </div>

          <div className={st.SidebarActions}>
            <DeleteCardsButton
              cardIds={[cardId]}
              onDeleteCards={() => {
                history.push(generatePath(routes.cardsAndLists.activeTab, { activeTab: 'cards' }));
              }}
            />
          </div>
        </div>

        <div className={st.Main}>
          <CardPageFastFilters />
          <CardFacesViewer />
        </div>
      </div>
    </div>
  );
}
